import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../api';
import { AppState } from '../../store/models/app-state';
import { Customer } from '../models/customer';

export const REQUEST_QUICKSEARCH = 'REQUEST_QUICKSEARCH';
export const REQUEST_QUICKSEARCH_COMPLETE = 'REQUEST_QUICKSEARCH_COMPLETE';
export const RECEIVE_QUICKSEARCH_RESULT = 'RECEIVE_QUICKSEARCH_RESULT';
export const RESET_QUICKSEARCH = 'RESET_QUICKSEARCH';

const requestQuickSearch = () => {
    return {
        type: REQUEST_QUICKSEARCH,
    };
};

const requestQuickSearchComplete = () => {
    return {
        type: REQUEST_QUICKSEARCH_COMPLETE,
    };
};

const receiveQuicksearchResult = (customers: Customer[]) => {
    return {
        type: RECEIVE_QUICKSEARCH_RESULT,
        customers,
    };
};

export const resetQuickSearch = () => {
    return {
        type: RESET_QUICKSEARCH,
    };
};

export const quickSearchCustomers = (searchParams: URLSearchParams) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch(requestQuickSearch());

        const response = await api.customer.search(searchParams);

        dispatch(requestQuickSearchComplete());
        if (response.success) {
            dispatch(receiveQuicksearchResult(response.result.items));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
